import React, { useEffect, useMemo, useRef, useState } from "react"
import StatsSummary from "../../components/GlobalComponent/StatsSummaryComponent";
import Page from "../../components/GlobalComponent/PageComponent";
import { ActiveInquiriesBreadcrumb } from "../../common/data/parties";
import ActiveInquiriesTable from "./component/ActiveInquiriesTable";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CommonValue } from "../Parties/PartiesCol";
import { QueriesColVal } from "../Sales/partials/SalesCol";
import { useDispatch } from "react-redux";
import {
    getNetworkInquiriesSummary,
    getSalesInquiryData
} from "../../store/Sales/actions";
import { formatModifyDate } from "../../components/Common/CommonLogic";
import { eye_icon } from "../../assets/images";
import FilterSalesInquiryComp from "../Sales/partials/FilterSalesInquiryComp";
import ButtonGroup from "../../components/GlobalComponent/ButtonGroupComponent";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import ViewDetails from "./modal/ViewDetails";
import {QUOTE_MODAL_INITIAL} from "../../store/Sales/Quotation/actiontype";
import { SMART_QUOTATION_VALUE_UPDATE } from "../../store/InstantRate/actionType";

const ActiveInquiries = () => {

    document.title = "Active Inquiries || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    const { inquiry_data_loader, networkInquiries } = useSelector((state) => state?.sales);
    const [isRight, setIsRight] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const dispatch = useDispatch();
    const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);
    const [inquiriesId, setInquiriesId] = useState();
    const [inquiriesType, setInquiriesType] = useState();

    const inputArr = {
        org_port: '',
        dest_port: '',
        status: '',
        valid_from: '',
        valid_to: '',
        customer: '',
        sales_employee: '',
        isExcelGenerated: false
    }
    const [filterDetails, setfilterDetails] = useState(inputArr);

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const toggleViewDetails = () => {
        setIsViewDetailsOpen(!isViewDetailsOpen);
    }

    const constructUrl = (page, filters) => {
        let url = `?page=${page}&size=${filterDetails?.isExcelGenerated ? inquiry_data?.totalElements : 10}&`;
        url += `${filters?.customer?.id ? `customers=${filters?.customer.id}&` : ''}`;
        url += `${filters?.org_port?.id ? `origins=${filters?.org_port.id}&` : ''}`;
        url += `${filters?.dest_port?.id ? `destinations=${filters?.dest_port.id}&` : ''}`;
        url += `${filters?.sales_employee?.id ? `salesEmployees=${filters?.sales_employee.id}&` : ''}`;
        url += `${filters?.valid_from ? `validFrom=${filters?.valid_from}&` : ''}`;
        url += `${filters?.valid_to ? `validTo=${filters?.valid_to}&` : ''}`;
        url += `${filters?.status?.id ? `status=${filters?.status?.id}&` : ''}`;
        url += `${filters?.container_type?.id ? `containerType=${filters?.container_type?.id}&` : ''}`;
        url += `${filterDetails?.isExcelGenerated ? `isExcelGenerated=${true}&` : ''}`;
        url += 'requestForRates=false&';
        return url.substring(0, url.length - 1); // Remove trailing '&'
    };

    const applyFilterHandler = () => {
        setIsRight(false);
        filterDetails.isExcelGenerated = false;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getSalesInquiryData(url));
    };

    const clearValueHandler = () => {
        setfilterDetails(inputArr);
        let url = constructUrl(currentPage, {});
        dispatch(getSalesInquiryData(url));
    };
    useEffect(() => {
        //let url = constructUrl(currentPage, filterDetails);
        //console.log(url);
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?isActiveInquiry=true&page=${currentPage}&size=10`;
            dispatch(getNetworkInquiriesSummary(url));
        }

    }, [dispatch, currentPage]);

    const downLoadExcelReport = () => {
        filterDetails.isExcelGenerated = true;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getSalesInquiryData(url));
    }

    const applyBids = (data) => {
        console.log(data, "applyBids")
        if(data.rateType === 'OCEAN_FCL') {
            dispatch({
                type: SMART_QUOTATION_VALUE_UPDATE,
                payload: { quote_currency: { value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0 } },
            });
        } else {
            dispatch({
                type: SMART_QUOTATION_VALUE_UPDATE,
                payload: { quote_currency: { value: 'INDIAN RUPEE', label: 'INR', currencyCode: 'INR', id: 2, version: 0 } },
            });
        }
        dispatch({ type: QUOTE_MODAL_INITIAL });
        navigate('/apply/quotation/bids', {
            state: {
                inquiriesId: data?.inquiryId,
                data: data
            },
        });
    };

    const viewDetails = (objData) => {
        setInquiriesType(objData?.rateType)
        setInquiriesId(objData?.inquiryId)
        toggleViewDetails();
    }

    const activeInquiriesStatsData = [
        {
            title: 'Active FCL Inquiries',
            value: networkInquiries?.totalFclInquiry || 0,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Active LCL Inquiries',
            value: networkInquiries?.totalLclInquiry || 0,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Active AIR Inquiries',
            value: networkInquiries?.totalAirInquiry || 0,
            percentage: 0,
            rate: '',
            rateType: 'up'
        }
    ];


    const columns = useMemo(() => [
        {
            Header: 'Inquiry Type',
            accessor: 'rateType',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{cellProps.row.original?.rateType.replace("_", " ")}</span>
                );
            }
        },
        {
            Header: 'Inquiry Dt',
            accessor: 'inquiryDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{formatModifyDate(cellProps.row.original?.inquiryDate)}</span>
                )
            }
        },
        {
            Header: 'Inquiry Id',
            accessor: 'inquiryId',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Shipper Location',
            accessor: 'tenantLocation',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'origin',
            accessor: 'origin',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Destination',
            accessor: 'destination',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Cargo Ready Date',
            accessor: 'cargoDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                if(cellProps?.row?.original?.rateType === 'AIR') {
                    const cargoDate = cellProps.row.original?.cargoDate;
                    return <span>{cargoDate ? formatModifyDate(cargoDate) : '/'}</span>;
                } else {
                    const cargoDate = cellProps.row.original?.cargoDate;
                    const cargoDateSplit = typeof cargoDate === "string" ? cargoDate.split('/') : [];
                    return (cargoDateSplit[0] !== "" && cargoDateSplit[1] !== "") ? (
                        <span>{formatModifyDate(cargoDateSplit[0])}/{formatModifyDate(cargoDateSplit[1])}</span>
                    ) : <span>/</span>;
                }
            }
        },
        {
            Header: 'Cargo Details',
            accessor: 'viewDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={(e) => {
                        e.stopPropagation();
                        viewDetails(cellProps.row.original);
                    }}>
                        <span className="align-content-center">View Details</span>
                    </label>
                )
            }
        },
        {
            Header: 'Status',
            accessor: 'statusCode',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Action',
            Cell: (cellProps) => {
                return (
                    <div className="row justify-content-center">
                        <div className="d-flex justify-content-center gap-2">
                            <ButtonGroup
                                showCancel={false}
                                showSubmit={true}
                                onSubmit={() => applyBids(cellProps.row.original)}
                                submitText="Submit Quote"
                                submitClass="btn btn-primary bid-btn"
                            />
                        </div>
                    </div>
                )
            }
        }
    ], []);

    return (
        <Page>
            <StatsSummary
                breadcrumb={ActiveInquiriesBreadcrumb}
                stats={activeInquiriesStatsData}
            />
            <ActiveInquiriesTable
                tableRef={tableRef}
                columns={columns}
                data={!!networkInquiries.content ? networkInquiries.content : []}
                isGlobalFilter={true}
                isAddInvoiceList={true}
                loader={inquiry_data_loader}
                customPageSize={10}
                toggleRightCanvas={toggleRightCanvas}
                downLoadExcelReport={downLoadExcelReport}
                component={'inquiryActive'}
                setCurrentPage={setCurrentPage}
                totalPages={networkInquiries?.totalPages || 0}
                totalEntries={networkInquiries?.totalElements || 0}
            />
            <FilterSalesInquiryComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />
            <ViewDetails isOpen={isViewDetailsOpen} inquirieType={inquiriesType} inquirieId={inquiriesId} toggle={toggleViewDetails} />
        </Page>
    )
}

export default ActiveInquiries;
